module.exports = "/images/app-store.png?da6bb328c7f125d66b80a9b7c8301d66";